import React, { useEffect, useContext } from 'react'
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Routes/AuthProvider";
//import { GetPaymentStatus } from "../Services/API";
import { FlightBooking } from "../Services/API";
import { BusBookingService } from "../Services/BusAPI";
import { bookHotel,hotelBookApproval } from "../Services/HotelSearchApi";
import { CreatePolicy } from "../Services/InsuranceApi";

const HdfcPaymentResponse = () => {
    const navigate = useNavigate();
    const { userName } = useContext(AuthContext);
    const query = new URLSearchParams(useLocation().search);
    const orderId = query.get("order_id");
    const key = query.get("key");
    const status = query.get("status");
    const productType = query.get("productType");
    const clientCode = "BerryJourneys";

    useEffect(() => {
        const CallFlightBooking = async () => {
            try {
                const response = await FlightBooking({
                    clientCode: "BerryJourneys",
                    userID: userName,
                    key: key,
                    referenceNo: orderId,
                });

                console.log("FlightBooking API Response:", response);

                if (response && response.error === null && (response.status === "Confirmed" || response.status === "Failure")) {
                    navigate(`/thankyou?ReferenceNo=${orderId}`);

                } else {
                    alert(response.error.description);
                    navigate(`/thankyou?ReferenceNo=${orderId}`);
                    console.error("Flight booking failed:", response);
                }

            } catch (error) {
                console.error("Error calling FlightBooking API", error);
            }
        };

        const CallBusBooking = async () => {
            try {
                const bookingResponse = await BusBookingService({
                    clientCode: "BerryJourneys",
                    userID: userName,
                    key: key,
                    referenceNo: orderId
                });
                console.log("Bus Booking API Response:", bookingResponse);
                navigate(`/Bus/Thankyou?ReferenceNo=${orderId}&clientCode=${clientCode}&key=${key}`);
            } catch (error) {
                console.error("Error calling Bus Booking API", error);
            }
        };

        const CallHotelBooking = async () => {
            try {
                const response = await hotelBookApproval({
                    // clientCode: "BerryJourneys",
                    // userID: userName,
                    // key: key,
                    // referenceNo: orderId,
                    
  bookingRefId: orderId

                });
                console.log("Hotel Booking API Response:", response);
                navigate(`/hotel/thankyou?ReferenceNo=${orderId}`);
            } catch (error) {
                console.error("Error calling Hotel Booking API", error);
            }
        };

        const CallInsuranceBooking = async () => {
            try {
                const response = await CreatePolicy({
                    clientCode: "BerryJourneys",
                    userID: userName,
                    key: key,
                    referenceNo: orderId,
                });
                console.log("Insurance Booking API Response:", response);
                navigate(`/insurance/Thankyou?ReferenceNo=${orderId}&Key=${key}&ClientCode=${clientCode}`);
            } catch (error) {
                console.error("Error calling Insurance Booking API", error);
            }
        };

        if (orderId && status === "CHARGED" && productType === "Flight") {
            CallFlightBooking();
        } else if (orderId && status === "CHARGED" && productType === "Hotel") {
            CallHotelBooking();
        } else if (orderId && status === "CHARGED" && productType === "Bus") {
            CallBusBooking();
        } else if (orderId && status === "CHARGED" && productType === "Insurance") {
            CallInsuranceBooking();
        }
        else {
            navigate(`/thankyou?ReferenceNo=${orderId}`);
        }

    }, [orderId, status, productType]);

    return (
        <>
            <p className="text-center load"><span className="loader"></span></p>
        </>
    )
}

export default HdfcPaymentResponse
